
export enum BarcodeTypeEnum {
    DC = 'DC',
    BUN = 'BUN'
}